import React from 'react';
import { withStyles } from '@glu/theming';
import { Redirect, Route, Switch } from 'react-router-dom';
import NoRouteMatch from 'components/errorBoundary/NoRouteMatch';
import { WORKFLOWS, WORKSPACES } from 'constants.js';
import PaymentRoutes from './payments';
import RecurringRoutes from './recurring/RecurringRoutes';
import TransferRoutes from './transfers/TransfersRoutes';
import routes from './routes';

const { PYMTCNTR } = WORKSPACES;
const { CREATE_RECURRING_TRANSFERS, TRANSFER } = WORKFLOWS;

/* istanbul ignore next */
const styles = {
  container: {
    position: 'relative'
  }
};

export function RoutingComponent() {
  const keys = Object.keys(routes);

  return (
    <React.Suspense fallback="">
      <Switch>
        {/* TODO: Start moving these routes into workspaces/categories */}
        {keys.map((r) => {
          const route = routes[r];
          const props = route?.component ? { ...route } : { component: route };
          return <Route key={r} path={r} {...props} />;
        })}
        {/* Payment Routes */}
        <Route path={`${PYMTCNTR}`} component={PaymentRoutes} />
        <Route path={`${CREATE_RECURRING_TRANSFERS}`} component={RecurringRoutes} />
        <Route path={`${TRANSFER}`} component={TransferRoutes} />
        <Route exact path="/">
          <Redirect to="/dashboard" />
        </Route>
        {/* 404 / Missing Page */}
        <Route component={NoRouteMatch} />
      </Switch>
    </React.Suspense>
  );
}

const StyledMain = withStyles(styles)(RoutingComponent);
export default StyledMain;
